var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"link",attrs:{"href":_vm.uri,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.resolvedLabel || _vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }